import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteAircraftDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  tailNumber: string
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteAircraftDialog({
  open,
  onOpenChange,
  tailNumber,
  onConfirm,
  isDeleting,
}: DeleteAircraftDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Aircraft</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete aircraft{' '}
            <span className="font-mono font-semibold">{tailNumber}</span>? This
            action cannot be undone. The aircraft will be soft-deleted and can
            be restored by an administrator.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
